export default __webpack_public_path__ + "359481be82c7194ed1f47e54d5e6f8ff.png";